export const parseOptionalDate = (
  value: number | string | Date | undefined | null,
): Date | null | undefined => {
  if (value == null) {
    return value;
  }
  return new Date(value);
};

export const parseRequiredDate = (value: number | string | Date): Date => {
  return new Date(value);
};
